import React, { Component } from "react";
import "./styles/skills.css";

export class skills extends Component {
  render() {
    return (
      <div className="SkillMain">
        <h1>Skills</h1>
        <div className="flexContainer">
          <div className="textList">
            <p>Java</p>
            <p>Swift</p>
            <p>Python</p>
            <br />
            <p>React JS</p>
            <br />
            <p>Git</p>
            <p>Jira</p>
          </div>
          <div className="rotatingPyramid">
            <div className="wrapper">
              <article id="viewport">
                <section id="pyramid">
                  <div className="pyramidSide1"></div>
                  <div className="pyramidSide2"></div>
                  <div className="pyramidSide3"></div>
                  <div className="pyramidSide4"></div>
                </section>
              </article>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default skills;
